import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import { FaArrowAltCircleRight } from "react-icons/fa";
import {
  register_ok_redirect_uri,
  api_v3_user_register_tournament,
  season_id,
  current_background_video,
  api_v3_get_tournament_by_id,
} from "../utils/constants";
import { useNavContext } from "../context/nav_context";
import { Loading, RegisterTournamentOk } from "../components";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

const RegisterTournamentPage = () => {
  const { tournamentId } = useParams();
  const { user } = useNavContext();
  const [step, setStep] = useState(1);
  const [discordUrl, setDiscordUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [registerCompleted, setRegisterCompleted] = useState(false);
  const [error, setError] = useState();
  const { accessToken } = useNavContext();
  const [, setTournament] = useState({});
  const [registersClosed, setRegistersClosed] = useState(true); // TODO: hacerlo en función del estado del torneo

  useEffect(() => {
    var url = new URL(
      "https://discord.com/api/oauth2/authorize?client_id=1042112312074588230&response_type=code&scope=identify%20email%20connections%20guilds%20guilds.join"
    );
    var search_params = url.searchParams;
    search_params.append("redirect_uri", register_ok_redirect_uri());
    search_params.append("state", tournamentId);
    url.search = search_params.toString();
    var new_url = url.toString();
    setDiscordUrl(new_url);
    console.log(new_url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadDivisions = async () => {
      const url = api_v3_get_tournament_by_id(tournamentId);

      try {
        const response = await axios.get(url);
        if (response.status === 200) {
          setTournament(response.data);
          if (response.data.status === "registers") {
            console.log("registers open");
            setRegistersClosed(false);
          }
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          return false;
        }
      } catch (error) {
        return false;
      }
    };

    loadDivisions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const registerInTournament = async () => {
    setLoading(true);
    setError("");
    setRegisterCompleted(false);
    try {
      var access_token = accessToken || localStorage.getItem("access_token");
      const config = {
        headers: { Authorization: `Bearer ${access_token}` },
      };

      const response = await axios.post(
        api_v3_user_register_tournament(tournamentId),
        {}, // no body
        config
      );
      if (response.status === 202) {
        console.log("User updated");
        setError("");
        setRegisterCompleted(true);
      }
    } catch (error) {
      console.log("error registering user");
      setError("Error actualizando datos del usuario. Inténtalo de nuevo.");
      setRegisterCompleted(false);
    }

    setLoading(false);
  };

  if (registersClosed) {
    return (
      <Wrapper>
        <div className="container">
          <video
            className="background-video"
            src={current_background_video}
            muted
            autoPlay
            preload="auto"
            loop
            type="video/mp4"
          ></video>
        </div>
        <Content>Las inscripciones a este torneo están cerradas.</Content>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <div className="container">
          <video
            className="background-video"
            src={current_background_video}
            muted
            autoPlay
            preload="auto"
            loop
            type="video/mp4"
          ></video>
        </div>

        <Content>
          <div className="info">
            <p>{error}</p>
            <span className="btn" onClick={() => registerInTournament()}>
              Registrarme como jugador
            </span>
          </div>
        </Content>
      </Wrapper>
    );
  }

  if (
    user &&
    ((user.seasonInfo &&
      user.seasonInfo.filter((s) => s.seasonId === season_id).length > 0) ||
      registerCompleted)
  ) {
    return <RegisterTournamentOk tournamentId={tournamentId} />;
  }

  if (loading) {
    return (
      <Wrapper>
        <div className="container">
          <video
            className="background-video"
            src={current_background_video}
            muted
            autoPlay
            preload="auto"
            loop
            type="video/mp4"
          ></video>
        </div>

        <Content>
          <div className="info">
            <Loading />
          </div>
        </Content>
      </Wrapper>
    );
  }

  // If user is logged, register in tournament
  if (user) {
    return (
      <Wrapper>
        <div className="container">
          <video
            className="background-video"
            src={current_background_video}
            muted
            autoPlay
            preload="auto"
            loop
            type="video/mp4"
          ></video>
        </div>

        <Content>
          <div className="info">
            <p>
              ¿Serás tan valiente para inscribirte en la liga? No creo, ¿NO?{" "}
            </p>
            <span className="btn" onClick={() => registerInTournament()}>
              Inscríbeme!!!
            </span>
          </div>
        </Content>
      </Wrapper>
    );
  }

  // If user is not logged, could be a new user or an existing one
  // 1. Show tutorial
  // 2. Log in / register user
  // 3. Register in tournament
  return (
    <Wrapper>
      <div className="container">
        <video
          className="background-video"
          src={current_background_video}
          muted
          autoPlay
          preload="auto"
          loop
          type="video/mp4"
        ></video>
      </div>

      {step === 1 ? (
        <Content>
          <p>Esta temporada es más fácil apuntarse.</p>
          <p>Solo tendrás que iniciar sesión con Discord.</p>
          <p>
            Pero antes revisa que tienes tu cuenta de Steam conectada con
            Discord.
          </p>
          <div className="register-options">
            <div className="options-center icon swing">
              <FaArrowAltCircleRight size={42} onClick={() => setStep(2)} />
            </div>
            <div className="options-right options">
              <p onClick={() => setStep(7)}>Omitir tutorial</p>
              <p onClick={() => setStep(7)}>No tengo el AoE2 en Steam</p>
            </div>
          </div>
        </Content>
      ) : (
        ""
      )}
      {step === 2 ? (
        <Content>
          <img
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/tutorial/register_tutorial_1.png"
            alt="tutorial paso 1"
          />
          <div className="register-options">
            <div className="options-center icon swing">
              <FaArrowAltCircleRight size={42} onClick={() => setStep(3)} />
            </div>
            <div className="options-right options">
              <p onClick={() => setStep(7)}>Omitir tutorial</p>
              <p onClick={() => setStep(7)}>No tengo el AoE2 en Steam</p>
            </div>
          </div>
        </Content>
      ) : (
        ""
      )}
      {step === 3 ? (
        <Content>
          <img
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/tutorial/register_tutorial_2.png"
            alt="tutorial paso 2"
          />
          <div className="register-options">
            <div className="options-center icon swing">
              <FaArrowAltCircleRight size={42} onClick={() => setStep(4)} />
            </div>
            <div className="options-right options">
              <p onClick={() => setStep(7)}>Omitir tutorial</p>
              <p onClick={() => setStep(7)}>No tengo el AoE2 en Steam</p>
            </div>
          </div>
        </Content>
      ) : (
        ""
      )}
      {step === 4 ? (
        <Content>
          <img
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/tutorial/register_tutorial_3.png"
            alt="tutorial paso 3"
          />
          <div className="register-options">
            <div className="options-center icon swing">
              <FaArrowAltCircleRight size={42} onClick={() => setStep(5)} />
            </div>
            <div className="options-right options">
              <p onClick={() => setStep(7)}>Omitir tutorial</p>
              <p onClick={() => setStep(7)}>No tengo el AoE2 en Steam</p>
            </div>
          </div>
        </Content>
      ) : (
        ""
      )}
      {step === 5 ? (
        <Content>
          <img
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/tutorial/register_tutorial_4.png"
            alt="tutorial paso 4"
          />
          <div className="register-options">
            <div className="options-center icon swing">
              <FaArrowAltCircleRight size={42} onClick={() => setStep(6)} />
            </div>
            <div className="options-right options">
              <p onClick={() => setStep(7)}>Omitir tutorial</p>
              <p onClick={() => setStep(7)}>No tengo el AoE2 en Steam</p>
            </div>
          </div>
        </Content>
      ) : (
        ""
      )}
      {step === 6 ? (
        <Content>
          <img
            src="https://alexocampos.github.io/liga-espanhola-aoe2-static/tutorial/register_tutorial_5.png"
            alt="tutorial paso 5"
          />
          <div className="register-options">
            <div className="options-center icon swing">
              <FaArrowAltCircleRight size={42} onClick={() => setStep(7)} />
            </div>
            <div className="options-right options">
              <p onClick={() => setStep(7)}>Omitir tutorial</p>
              <p onClick={() => setStep(7)}>No tengo el AoE2 en Steam</p>
            </div>
          </div>
        </Content>
      ) : (
        ""
      )}
      {step === 7 ? (
        <Content>
          <a href={discordUrl} rel="noopener noreferrer">
            <DiscordIcon>
              <img
                src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/discord.png"
                alt="discord"
              />
              <span>Registro con Discord</span>
            </DiscordIcon>
          </a>
        </Content>
      ) : (
        ""
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .registers {
    text-decoration: underline;
    transition: 0.5ms;
  }

  .registers a:hover {
    color: var(--clr-primary-light-2);
  }

  .container {
    width: 100%;
    height: 88vh;
    position: absolute;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .background-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -10;
    position: absolute;
  }
`;

const Content = styled.div`
  width: 100%;
  height: 50vh;
  margin-top: 10vh;
  margin-bottom: 25vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  font-size: 1.5rem;

  .info {
    margin-left: 2rem;
    margin-right: 2rem;
    background-color: var(--black-transparency);
    padding: 2rem;
  }

  a:hover {
    color: var(--clr-grey-1);
  }

  img {
    width: 55vw;
    margin-bottom: 2rem;
  }

  .icon {
    cursor: pointer;
  }

  .register-options {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .options-center {
  }
  .options-right {
    position: absolute;
    right: 10rem;
    font-size: 1rem;
    text-decoration: underline;
    text-align: right;

    p {
      cursor: pointer;
    }
  }

  @media (max-width: 992px) {
    padding: 1rem;

    img {
      width: 100%;
      margin-bottom: 2rem;
    }

    .register-options {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      align-items: center;
    }

    .options-center {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 2rem;
    }

    .options-right {
      position: inherit;
      right: 1rem;
      width: 100%;
    }
  }
`;

const DiscordIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 3rem;
  cursor: pointer;

  background-color: var(--clr-discord);
  transition: color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  box-shadow: inset 0 0 0 0 var(--clr-discord-hover);

  img {
    width: 2.4rem;
    margin: 0.3rem;
  }
  span {
    height: 3rem;
    margin: 0;
    padding: 0.5rem;
  }

  :hover {
    /* background-color: var(--clr-discord-hover); */
    box-shadow: inset 100rem 0 0 0 var(--clr-discord-hover);
  }
`;

export default RegisterTournamentPage;
